<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px',
        background: '#fff',
        minHeight: '100px'
      }"
    >
      <a-form-model layout="inline" :model="formInline" @submit.native.prevent>
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="函数名称">
              <a-input v-model="formInline.functionName" placeholder="请输入函数名称">
                <a-icon slot="prefix" type="search" style="color: rgba(0,0,0,0.25)" />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="场景">
              <a-select v-model="formInline.scenario" placeholder="全部" allow-clear style="width: 100%" :dropdown-style="{ minWidth: '120px' }">
                <a-select-option value="default">默认</a-select-option>
                <a-select-option value="product">商品</a-select-option>
                <a-select-option value="order">订单</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <aiFunctionConfig :formInline="formInline" ref="configRef"></aiFunctionConfig>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import aiFunctionConfig from "./aiFunctionConfig.vue";

export default {
  components: {
    aiFunctionConfig: aiFunctionConfig
  },
  data: function () {
    return {
      formInline: {
        functionName: "",
        scenario: undefined
      }
    };
  },
  methods: {
    search: function () {
      this.$refs.configRef.getData();
    },
    resetForm: function () {
      this.formInline.functionName = "";
      this.formInline.scenario = undefined;
      this.$refs.configRef.getData();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/aiFunctionConfig/aiFunctionConfigHome.vue